import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/pCqtwWrKyjBbHU5W7",
  address: "Unit 34A, Cameron Toll Shopping Centre - 6 Lady Rd, Edinburgh EH16 5PB",
  ggMapIframeUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3373.311039625186!2d-3.1640435!3d55.9269828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887b9ac1a1fb87d%3A0x88451f86e2cf2b37!2sBeauty%20Boutique%20Nails!5e1!3m2!1sen!2s!4v1774964183886!5m2!1sen!2s",
  email: "mybeautynail.camerontoll@gmail.com",
  tel: "+447459958333",
  phone: "+44 745 995 8333",
  facebookId:"100090296830877",
  instagramName: "beautyboutique.camerontoll",
  name: "Beauty Boutique Nails",
  bookingUrl: "https://beautyboutiquenails.setmore.com",
  openingTime: [
    { weekdays: "MONDAY - FRIDAY", time: "09:30AM - 06:30PM" },
    { weekdays: "SATURDAY", time: "09:30AM - 06:00PM" },
    { weekdays: "SUNDAY", time: "10:30AM - 05:30PM" },
  ],
};
NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`
export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",
  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Laila Blackheart",
    feedback:
      "â€œMy partner and I just moved to the area and wanted to treat ourselves to a couples pedicure. We called only 30 minutes before closing and they still managed to fit us in, which we really appreciated! They welcomed us with green tea and refreshments, and everyone was super professional and friendly.\n\nIt was my partnerâ€™s first time getting a pedicure and they made him feel totally comfortable. They did such a thorough job on both of us, we were seriously impressed with the attention to detail. Highly recommend!â€",
    avatar: "https://i.imgur.com/sU1i6Sk.png",
  },
   {
    name: "Finlay Lewis",
    feedback:
      "â€œThe best place. Great environment you get offered snacks and drinks on arrival and get treated very well. I loved my nails they make sure they take time to ensure youâ€™re happy and never rush you out of the shop. They are all very talented and kind! Couldnâ€™t recommend this place enough. Anna is the best at doing my nails- sheâ€™s so talented and does the best nails in London!â€",
    avatar: "https://i.imgur.com/RsFFmiS.png",
  },
  {
    name: "Natalie Jackman",
    feedback:
      "â€œAmazing best nail salon. Iâ€™ve been coming since start of the 2025 and the nail techs are all spot on. Customer service is great and Iâ€™m always greeted with a smile and a hot drink . I always leave with a smile and beautiful nails . Thank youâ€",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Eve Sylvie Watcon",
    feedback:
      "â€œOnly ever had a nice experience here. Really nice people and a great service. Couldnâ€™t recommend more!! Thank you Ana and William ðŸ˜Š â€¦â€",
    avatar: "https://i.imgur.com/Lq7YQ1o.png",
  },
  {
    name: "Zainab Rasak",
    feedback:
      "â€œAmazing service, the people are really nice and friendly. And my nails look great! Thank you!â€",
    avatar: "https://i.imgur.com/HDBW1Xg.png",
  },
  {
    name: "Kim Mee",
    feedback:
      "â€œThanks for putting my wonderful nails on your profile. I really like my wonderful nails and make my love look more romantic. Thanks Beauty Boutique Nails again so muchðŸ¥°ðŸ¥°â€",
    avatar: "https://i.imgur.com/Ds2X7zK.png",
  },
  {
    name: "Sharna Walsh",
    feedback:
      "â€œAmazing staff perfect nails listen to everything I like beautiful nails vet happy and will definitely returnâ€",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Mary Shannal",
    feedback:
      "â€œA great nail salon, they made me a beautiful set of nails. The decoration is luxurious, clean, disinfecting everything including the massage chair but the price is very good and not expensive at all. They always ask for advice. me before and after. I would recommend this bail salon and will come back often for beauty and relaxationâ€",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
];

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
